import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProjectService {
    /**
     * Get project by Id
     * @param projectId
     * @returns ProjectBoInterface
     * @throws ApiError
     */
    static projectGetProject(projectId) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/project/{projectId}',
            path: {
                'projectId': projectId,
            },
        });
    }
    /**
     * Updates a draft project entity
     * @param projectId
     * @param requestBody
     * @returns ProjectBoInterface
     * @throws ApiError
     */
    static projectUpdateProject(projectId, requestBody) {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/project/{projectId}',
            path: {
                'projectId': projectId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Archive a project
     * @param projectId
     * @returns boolean
     * @throws ApiError
     */
    static projectDeleteProject(projectId) {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/project/{projectId}',
            path: {
                'projectId': projectId,
            },
        });
    }
    /**
     * Get all projects attributed to the token's userId
     * @returns ProjectBoInterface
     * @throws ApiError
     */
    static projectGetAllProjects() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/project',
        });
    }
    /**
     * Creates a new draft project entity
     * @param requestBody
     * @returns ProjectBoInterface
     * @throws ApiError
     */
    static projectCreateProject(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/project',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get all projects attributed to the token's userId by query
     * @param requestBody
     * @returns ProjectBoInterface
     * @throws ApiError
     */
    static projectGetProjectsByQuery(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/project/query',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * Get all project action requests
     * @param projectId
     * @returns ActionRequestBoInterface
     * @throws ApiError
     */
    static projectGetProjectRequests(projectId) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/project/{projectId}/actions',
            path: {
                'projectId': projectId,
            },
        });
    }
    /**
     * Get action jobs by request id
     * @param projectId
     * @returns ActionJobBoInterface
     * @throws ApiError
     */
    static projectGetActionJobs(projectId) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/project/{projectId}/actionJobs',
            path: {
                'projectId': projectId,
            },
        });
    }
    /**
     * Get rewrite jobs by request id
     * @param projectId
     * @returns RewriteJobBoInterface
     * @throws ApiError
     */
    static projectGetRewriteJobs(projectId) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/project/{projectId}/rewriteJobs',
            path: {
                'projectId': projectId,
            },
        });
    }
    /**
     * Sets project status to Active. Creates queued jobs from all attributed ActionRequests
     * @param projectId
     * @returns boolean
     * @throws ApiError
     */
    static projectActivateProject(projectId) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/project/activate/{projectId}',
            path: {
                'projectId': projectId,
            },
        });
    }
}
